
import { Col, Container, Row } from "reactstrap";
import { GetInTouch } from "../../../constants";
import { ContactBoxData, TouchContent } from "../../../data/pages/Other";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import CommonHeader from "../../home/common/CommonHeader";
import SellYourCarContactForm from "./common/SellYourCarContactForm";
import { dynamicImage, Image } from "../../../utils";
import Faq from "../../commonComponents/productDetail/detailBody/detailBodyItem/Faq";

const Services1Container = () => {
  return (
    <>
      <Breadcrumbs title="Services" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section" />
      <section className="contact-section contact-2-section mb-5">
        <Container>

          <Faq />

        </Container>
      </section>
    </>
  );
};

export default Services1Container;
